/**
 * JWT access + refresh in localStorage. Lives in a separate module so httpInstance
 * can import it without a circular dependency with AuthService (which imports http).
 */

const ACCESS_KEY = "token";
const REFRESH_KEY = "jwt_refresh";

export function getAccessToken() {
  return localStorage.getItem(ACCESS_KEY);
}

export function setAccessToken(value) {
  if (value == null || value === "") {
    localStorage.removeItem(ACCESS_KEY);
    return;
  }
  localStorage.setItem(ACCESS_KEY, value);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}

export function setRefreshToken(value) {
  if (value == null || value === "") {
    localStorage.removeItem(REFRESH_KEY);
    return;
  }
  localStorage.setItem(REFRESH_KEY, value);
}

/** Persist tokens from login or refresh response (legacy field `token` = access). */
export function persistAuthFromResponse(body) {
  if (!body || typeof body !== "object") return;
  if (body.token) setAccessToken(body.token);
  if (body.access) setAccessToken(body.access);
  if (body.refresh) setRefreshToken(body.refresh);
}

export function clearAuthTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
